import React from 'react'

const Controls = ({handleInput}) => {
	return(
		<div className="row">
			<div className="medium-6 columns">
				<button className="button full small"
					name="clear"
					onClick={handleInput}>
					Clear Form
				</button>
			</div>
			<div className="medium-6 columns">
				<button className="button full small"
					name="sample"
					onClick={handleInput}>
					See Sample
				</button>
			</div>
		</div>
	)
}

export default Controls;